<template>
 <div class="is-marginless is-paddingless section section-details">
    <div class="entête border-entete">
     <div class="columns mgb-0">
        <div class="column pdb-0">
          <h1 class="title is-size-3">
            {{ titlePage }}
          </h1>
        </div>
      </div>
      <app-breadcrumb :breadcrumb="breadcrumb"/>
    </div>
    <div class="has-text-centered pdt-20px">
      <img :src="logo"/>
    </div>
 </div>
</template>

<script>
import AppBreadcrumb from '@/components/general/breadcrumb';
import { getFullLogo } from '@/services/general/getLogo';
import messageErreur from '@/services/general/messageErreur';

export default {
  name: 'detailImage',
  components: {
    AppBreadcrumb,
  },
  data() {
    return {
      logo: null,
    };
  },
  computed: {
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('general.detailLogo.breadcrumb'), route: { name: 'detail-image-produit' }, isActive: true },
      ];
    },
    titlePage() {
      return this.$route.params.libelle ? this.$route.params.libelle : this.$i18n.t('detailLogo.title');
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.logo = await getFullLogo(this.$route.params.id);
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.$route.params.libelle }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
